import FolderOverview from 'scoreboard/components/folder-overview'

var ReportsFolderOverview = FolderOverview.extend({

	secure: function() {
		this.header.conditionallyHideEditTab(this.model.isEditable())
	}

})

export default ReportsFolderOverview

ReportsFolderOverview.__filename__ = 'reports/reports-folder-overview.js'
